import {
  UpdateCompanyDetailsRequest,
  RegisterCompanyDataDto,
  CompanyDetailsDto,
} from '@interfaces/models';
import { httpClient } from '@api/interceptors';

export const getCompanyDetails = (id: string): Promise<CompanyDetailsDto> => {
  return httpClient.get(`companies/${id}`).json();
};

export const updateCompanyDetails = ({
  id,
  data,
}: {
  data: UpdateCompanyDetailsRequest;
  id: CompanyDetailsDto['id'];
}) => {
  return httpClient.put(`companies/${id}`, { json: data });
};

export async function getCompanyData(nip: string): Promise<RegisterCompanyDataDto> {
  return httpClient.get(`government/data/${nip}`).json();
}
